import React from 'react';
import { motion } from 'framer-motion';

export default function Settings({ onClose }) {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
    >
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="modal-content relative w-[90%] max-w-[500px] p-8 pointer-events-none"
        style={{
          background: 'linear-gradient(45deg, #2F1810 0%, #4A2511 100%)',
          border: '8px solid',
          borderImage: 'linear-gradient(45deg, #B8860B, #CD853F) 1',
          boxShadow: '0 0 30px rgba(184, 134, 11, 0.3)',
        }}
      >
        {/* Decorative Corner Gears */}
        <div className="absolute top-0 left-0 w-16 h-16 pointer-events-none"
          style={{
            background: 'radial-gradient(circle, #B8860B 20%, transparent 70%)',
            opacity: 0.3,
            animation: 'spin 10s linear infinite',
          }}
        />
        <div className="absolute top-0 right-0 w-16 h-16 pointer-events-none"
          style={{
            background: 'radial-gradient(circle, #B8860B 20%, transparent 70%)',
            opacity: 0.3,
            animation: 'spin 10s linear infinite reverse',
          }}
        />

        <h2 
          className="text-3xl mb-8 text-center font-playfair text-[#D4AF37] pointer-events-none"
          style={{
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
          }}
        >
          Settings
        </h2>
        
        <div className="space-y-6 bg-[#1A0F0A] p-6 rounded">
          <div className="flex items-center justify-between">
            <span className="text-[#CD853F] font-playfair text-lg pointer-events-none">Music Volume</span>
            <input 
              type="range" 
              className="w-32 h-2 appearance-none bg-[#2F1810] rounded-full pointer-events-auto z-52
                [&::-webkit-slider-thumb]:appearance-none
                [&::-webkit-slider-thumb]:w-4
                [&::-webkit-slider-thumb]:h-4
                [&::-webkit-slider-thumb]:rounded-full
                [&::-webkit-slider-thumb]:bg-gradient-to-r
                [&::-webkit-slider-thumb]:from-[#B8860B]
                [&::-webkit-slider-thumb]:to-[#CD853F]
                [&::-webkit-slider-thumb]:cursor-pointer
                [&::-webkit-slider-thumb]:shadow-lg"
            />
          </div>
          
          <div className="flex items-center justify-between border-t border-[#B8860B]/30 pt-6">
            <span className="text-[#CD853F] font-playfair text-lg pointer-events-none">Sound Effects</span>
            <input 
              type="range" 
              className="w-32 h-2 appearance-none bg-[#2F1810] rounded-full pointer-events-auto z-52
                [&::-webkit-slider-thumb]:appearance-none
                [&::-webkit-slider-thumb]:w-4
                [&::-webkit-slider-thumb]:h-4
                [&::-webkit-slider-thumb]:rounded-full
                [&::-webkit-slider-thumb]:bg-gradient-to-r
                [&::-webkit-slider-thumb]:from-[#B8860B]
                [&::-webkit-slider-thumb]:to-[#CD853F]
                [&::-webkit-slider-thumb]:cursor-pointer
                [&::-webkit-slider-thumb]:shadow-lg"
            />
          </div>
          
          <div className="flex items-center justify-between border-t border-[#B8860B]/30 pt-6">
            <span className="text-[#CD853F] font-playfair text-lg pointer-events-none">Text Speed</span>
            <input 
              type="range" 
              className="w-32 h-2 appearance-none bg-[#2F1810] rounded-full pointer-events-auto z-52
                [&::-webkit-slider-thumb]:appearance-none
                [&::-webkit-slider-thumb]:w-4
                [&::-webkit-slider-thumb]:h-4
                [&::-webkit-slider-thumb]:rounded-full
                [&::-webkit-slider-thumb]:bg-gradient-to-r
                [&::-webkit-slider-thumb]:from-[#B8860B]
                [&::-webkit-slider-thumb]:to-[#CD853F]
                [&::-webkit-slider-thumb]:cursor-pointer
                [&::-webkit-slider-thumb]:shadow-lg"
            />
          </div>
        </div>

        <button 
          onClick={onClose}
          className="w-full mt-8 py-3 px-6 text-lg font-playfair text-[#2F1810] pointer-events-auto z-52
            relative overflow-hidden transition-all duration-300
            bg-gradient-to-r from-[#B8860B] to-[#CD853F] 
            hover:from-[#CD853F] hover:to-[#B8860B]
            rounded shadow-lg hover:shadow-xl
            transform hover:-translate-y-0.5"
          style={{
            textShadow: '1px 1px 2px rgba(255,255,255,0.3)',
          }}
        >
          Close
        </button>
      </motion.div>
    </motion.div>
  );
}
